/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCompanyCommand
 */
export interface UpdateCompanyCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyCommand
     */
    name?: string | null;
}

/**
 * Check if a given object implements the UpdateCompanyCommand interface.
 */
export function instanceOfUpdateCompanyCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateCompanyCommandFromJSON(json: any): UpdateCompanyCommand {
    return UpdateCompanyCommandFromJSONTyped(json, false);
}

export function UpdateCompanyCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function UpdateCompanyCommandToJSON(value?: UpdateCompanyCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

